<template>
  <Layout>
    <div>
      <h1>Welcome to ISACI</h1>

      <div class="row">
        <div class="col-sm-6">
          <div class="h-blue">
            Welcome to ISACI!
          </div>
          <div>
            <h4>Quick Links</h4>
            <div>
              <strong>ISACI 22nd Annual Meeting:</strong><br>
              <ul>
                <li><router-link to="/registration">Register for Meeting</router-link></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="h-red">
            Announcements
          </div>
          <div class="announcement-list">
            <div class="announcement" v-for="announcement in announcements" :key="announcement.id">
              <strong>{{ announcement.date }}</strong><br>
              <a :href="announcement.link">{{ announcement.title }}</a> ... {{ announcement.author }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import { apiService } from '@/config/api'

export default {
  name: 'Home',
  components: {
    Layout
  },
  data() {
    return {
      announcements: [
        {
          id: 1,
          date: '26 May 2025 22:37:14 PM',
          title: 'AOGS2025 Early Bird Registration and Presentation Registration',
          link: '#',
          author: 'Ji Chen (ISACI Secretary General)'
        },
        {
          id: 2,
          date: '15 November 2024 17:48:35 PM',
          title: 'Call for Abstracts and Funding Support Application',
          link: '#',
          author: 'Cheng Hoon Khoo (ISACI Secretariat)'
        },
        {
          id: 3,
          date: '15 October 2024 18:38:38 PM',
          title: 'ISACI 2025 Session Proposal Deadline Extended to 22 Oct 2024 (2359hrs; GMT +8)',
          link: '#',
          author: 'Cheng Hoon Khoo (ISACI Secretariat)'
        },
        {
          id: 4,
          date: '14 October 2024 10:35:54 AM',
          title: 'Soliciting Session Proposals for ISACI 2025',
          link: '#',
          author: 'Ji Chen (ISACI Secretary General)'
        },
        {
          id: 5,
          date: '25 August 2024 16:09:26 PM',
          title: 'Visit ISACI at Booth E27 - International Geological Congress 2024',
          link: '#',
          author: 'Cheng Hoon Khoo (ISACI Secretariat)'
        },
        {
          id: 6,
          date: '19 December 2023 13:42:03 PM',
          title: 'Reminder: AOGS2024 Abstract Submission Deadline Approaching',
          link: '#',
          author: 'Cheng Hoon Khoo (Conference Secretariat)'
        },
        {
          id: 7,
          date: '23 October 2023 08:21:49 AM',
          title: 'Invitation to Society\'s 2024 Annual Meeting and Award Nominations',
          link: '#',
          author: 'Chun-Chieh Wu (ISACI President)'
        }
      ]
    }
  },
  mounted() {
    this.getAnnouncements()
  },
  methods: {
    async getAnnouncements() {
      const response = await apiService.announcements.getList()
    //   this.announcements = response.data.data
    }
  }
}
</script>

<style scoped>
/* 样式已在common.css中定义 */
</style> 